/** The approved golden-square PF mark, shared by every application surface. */
export function BrandMark({ className = "" }: { className?: string }) {
  return (
    <svg
      className={`brand-mark ${className}`.trim()}
      viewBox="0 0 432 432"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <use href="/brand/proxima-forma-mark.svg?v=golden-square#mark" />
    </svg>
  );
}
